import { redirect } from '@tanstack/react-router';

import { isSkillWorkflowsEnabled } from '../../config/global';

/** Route guard: without the feature flag the editor and gallery routes do not exist. */
export function requireSkillWorkflows() {
  if (!isSkillWorkflowsEnabled()) throw redirect({ to: '/skills' });
}
